import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconPlusLarge"><Path fillRule="evenodd" clipRule="evenodd" d="M12 3C12.2761 3 12.5 3.22386 12.5 3.5V11.5H20.5C20.7761 11.5 21 11.7239 21 12C21 12.2761 20.7761 12.5 20.5 12.5H12.5V20.5C12.5 20.7761 12.2761 21 12 21C11.7239 21 11.5 20.7761 11.5 20.5V12.5H3.5C3.22386 12.5 3 12.2761 3 12C3 11.7239 3.22386 11.5 3.5 11.5H11.5V3.5C11.5 3.22386 11.7239 3 12 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusLarge;
